<template>
  <b-container fluid>
    <b-row class="m-3 p-3" v-if="$route.params.msg">
      <b-col>
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          class="text-center"
          @dismissed="dismissCountDown=0"
        >{{ $route.params.msg }}</b-alert>
      </b-col>
    </b-row>
    <div v-if="stripeConnectUserId" class="main-page">
      <b-img src="../../static/images/main_header_pic.svg" center fluid />
      <div class="centered" style="color: white;">
        <b-button
          size="lg"
          variant="danger"
          @click="$router.push({ name: 'QRReader' })"
        >{{ $t('Home.scan') }}</b-button>
      </div>
    </div>
    <div v-else-if="isUserLoggedIn">
      <b-row class="mt-3 justify-content-center">
        <div style="padding: 10px;">
          <h3>
            {{ $t('Home.noStripeConnectUserLoggedInWelcomeMsg') }}
            <font-awesome-icon icon="smile" />
          </h3>
          {{ $t('Home.noStripeConnectUserLoggedInInstructionsPart1') }}
          <router-link
            :to="{name: 'StripeConnectStart'}"
          >{{ $t('Home.noStripeConnectUserLoggedInInstructionsPart2') }}</router-link>
        </div>
      </b-row>
    </div>
    <div v-else-if="noStripeNoUser">
      <b-row class="mt-3 justify-content-center">
        <div style="padding: 10px;">
          <h3>
            {{ $t('Home.noStripeConnectUserNotLoggedInWelcomeMsg') }}
            <font-awesome-icon icon="smile" />
          </h3>
          {{ $t('Home.noStripeConnectUserNotLoggedInInstructionsPart1') }}
          <router-link
            :to="{name: 'Login'}"
          >{{ $t('Home.noStripeConnectUserNotLoggedInInstructionsPart2') }}</router-link>
          {{ $t('Home.noStripeConnectUserNotLoggedInInstructionsPart3') }}
        </div>
      </b-row>
    </div>
    <div class="text-center" v-if="spinner">
      <b-spinner variant="danger" label="Spinning"></b-spinner>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  data () {
    return {
      dismissCountDown: 20,
      noStripeNoUser: false,
      spinner: true
    }
  },
  mounted () {
    // redirect if temp password
    this.changePassword()
    // redirect if table already set
    this.goToMenu()
    // if no stripe account set and no user logged in
    // wait one second and render page accordingly
    this.setNoStripeNoUser()
  },
  methods: {
    setNoStripeNoUser () {
      if (!this.stripeConnectUserId) {
        if (!this.isUserLoggedIn) {
          setTimeout(() => {
            this.noStripeNoUser = true
          }, 1000)
        } else this.spinner = false
      } else this.spinner = false
    },
    changePassword () {
      if (this.user) {
        if (this.user.resetPassword) {
          // redirect to change password
          this.$router.push({
            name: 'ChangePassword',
            params: { msg: this.$i18n.t('Home.setPermanentPassword') }
          })
        }
      }
    },
    goToMenu () {
      // first check that the application is bootstrapped
      if (this.stripeConnectUserId) {
        if (this.tableNumber) {
          // redirect to change password
          this.$router.push({
            name: 'Categories'
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      tableNumber: 'tableNumber',
      stripeConnectUserId: 'stripeConnectUserId',
      isUserLoggedIn: 'isUserLoggedIn'
    })
  },
  watch: {
    stripeConnectUserId: function () {
      if (this.stripeConnectUserId) {
        this.spinner = false
        if (this.tableNumber) {
          // redirect to change password
          this.$router.push({
            name: 'Categories'
          })
        }
      }
    },
    isUserLoggedIn: function () {
      if (this.isUserLoggedIn) {
        this.spinner = false
      }
    },
    noStripeNoUser: function () {
      if (this.noStripeNoUser) {
        this.spinner = false
      }
    }
  }
}
</script>

<style scoped>
div.main-page {
  padding: 0;
  position: relative;
  text-align: center;
  color: white;
}
/* Centered text */
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
img {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue